import React from 'react'

function Update() {
  return (
    <div>Update</div>
  )
}

export default Update